import adminMiddleware from "@/components/donations/admin/ducks/middleware"
import userMiddleware from "@/components/donations/ducks/middleware"
import volunteerMiddleware from "@/components/donations/volunteer/ducks/middleware"

export default [adminMiddleware, userMiddleware, volunteerMiddleware]
